import React from 'react';

/**
 * Cloud with a slash — "we couldn't reach the site". Stroked Lucide-parity
 * style (24x24, fill=none). Used by the discovery report's SEO-unreachable
 * notice (GEN-2319). Decorative: callers carry the meaning in adjacent text
 * and mark this `aria-hidden`.
 */
export function CloudSlashIcon({
  className = 'h-5 w-5',
}: {
  className?: string;
}): React.ReactElement {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 3l18 18M6.6 8.5A5 5 0 008 18h9a4 4 0 001.4-7.75M9 5.5A5 5 0 0117.9 9.2"
      />
    </svg>
  );
}
